import React, { useState } from 'react';
import { Box, IconButton, Paper, Typography, Collapse } from '@mui/material';
import { BugReport } from '@mui/icons-material';

/**
 * Debug component that displays environment configuration
 * Only visible in QA environment
 */
const DebugInfo = () => {
  const [open, setOpen] = useState(false);

  // Only show in QA environment
  const isQA = process.env.PUBLIC_URL === '/qa';
  if (!isQA) return null;

  const debugInfo = {
    'PUBLIC_URL': process.env.PUBLIC_URL || '(empty)',
    'API_BASE_URL': process.env.REACT_APP_API_BASE_URL || '(empty)',
    'NODE_ENV': process.env.NODE_ENV,
    'Window Location': window.location.href,
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
      }}
    >
      <IconButton
        onClick={() => setOpen(!open)}
        sx={{
          bgcolor: 'error.main',
          color: 'white',
          '&:hover': { bgcolor: 'error.dark' },
          mb: open ? 1 : 0,
        }}
        size="small"
      >
        <BugReport />
      </IconButton>

      <Collapse in={open}>
        <Paper
          elevation={8}
          sx={{
            p: 2,
            bgcolor: 'grey.900',
            color: 'white',
            minWidth: 300,
            maxWidth: 400,
          }}
        >
          <Typography variant="h6" gutterBottom sx={{ color: 'error.main' }}>
            Debug Info (QA Only)
          </Typography>
          {Object.entries(debugInfo).map(([key, value]) => (
            <Box key={key} sx={{ mb: 1 }}>
              <Typography variant="caption" sx={{ color: 'grey.400' }}>
                {key}:
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  wordBreak: 'break-all',
                  fontFamily: 'monospace',
                  bgcolor: 'grey.800',
                  p: 0.5,
                  borderRadius: 0.5,
                }}
              >
                {value}
              </Typography>
            </Box>
          ))}
        </Paper>
      </Collapse>
    </Box>
  );
};

export default DebugInfo;
